module.exports = __webpack_public_path__ + "media/bootstrap-icons/signpost-21b9c038.svg";